const sidebar = (props) => {
    return (
        <div id={props.id} className={'mdc-elevation--z6 sidebar' + (props.shown ? '' : ' sidebar--hidden')}>
            {props.children}
        </div>
    )
}

export default sidebar